<template>
  <div class="content-message">
    <div class="title">公众号授权</div>
    <div class="flex">
    <div class="official">
      <div class="official-top">
        <div class="top-button" @click="toPay(1)">+ 添加公众号</div>

      </div>
      <div class="official-div" v-for="(item,index) in canAuthAppNum">
        <div class="message">
          <div  class="header-nodata"></div>
          <div class="message-name">
            <div class="name">未绑定</div>
          </div>
        </div>
<!--        <a :href="authLink">-->
        <div class="official-add" @click="addOfficial = true">
          绑定公众号
        </div>
<!--        </a>-->
      </div>
      <div class="official-div" v-for="(item,index) in list" :key="index">
        <div class="message">
          <img :src="item.appImg" alt="">
          <div class="message-name">
            <div class="name">{{ item.appName }}</div>
<!--              判断是否小于30天即将过期-->
            <div class="name" :class="Date.parse(item.movieExpirationTime) - new Date().getTime() < 1000 * 3600 * 24 * 30?'active':''">{{ item.movieExpirationTime }}到期<div style="color: #FF8622; " v-if="Date.parse(item.movieExpirationTime) - new Date().getTime() < 1000 * 3600 * 24 * 30 && Date.parse(item.movieExpirationTime) - new Date().getTime() > 0">（即将到期）</div><div style="color: red; " v-if="Date.parse(item.movieExpirationTime) - new Date().getTime() < 0">（已到期）</div></div>
          </div>
        </div>
        <div class="button">
          <div class="button-look" @click="check(item.id)">查看推广链接</div>
          <div class="official-add" @click="toPay(2,item.id)">
            续费
          </div>
          <div class="top-message" @click="synchronization(item)">同步消息模板</div>
        </div>
      </div>
    </div>
      <div class="notice-box">
        <div class="auth-title">注意事项</div>
        <div class="auth-tip">
          <div class="part-box">
            <div class="part-circle"></div>
            <div class="part-content"><span>授权成功后，请先<span class="sync-template">同步消息模版</span></span></div>
          </div>
          <div class="part-box">
            <div class="part-circle"></div>
            <div class="part-content"><span>不要手动去删除微信公众号生成的消息模板</span></div>
          </div>
          <div class="part-box">
            <div class="part-circle"></div>
            <div class="part-content"><span>有任何使用券码的问题，及时联系客服</span></div>
          </div>
        </div>
        <div class="qrcode-box">
          <div class="qrcode-div">
            <img class="qrcode-img" src="../../../../assets/img/official/service1.jpg" alt="">
            <div class="nickname">守兔票务-雪糕</div>
          </div>
          <div class="qrcode-div" style="margin-left: 20px">
            <img class="qrcode-img" src="../../../../assets/img/official/service2.jpg" alt="">
            <div class="nickname">守兔票务-婷欧尼</div>
          </div>
        </div>
      </div>
    </div>
<!--    绑定公众号-->
    <el-dialog
      title="绑定公众号"
      :visible.sync="addOfficial"
      width="60%"
      :before-close="handleClose">
      <div class="add-message">
        <div class="bottom">
          <div><img class="img" src="../../../../assets/img/kfc/wechat_shouquanshuoming.png" alt=""></div>
          <div>
            <div class="bottom-title">授权说明</div>
            <div class="bottom-item">
              <div class="bor"></div>
              <div class="item-text">授权过程需要该公众号的管理员扫码，管理员一般是注册公众号的人，运营者是不能授权的。</div>
            </div>
            <div class="bottom-item">
              <div class="bor"></div>
              <div class="item-text">如果你是公众号的管理员，点击下方按钮，扫码授权即可。</div>
            </div>
            <div class="bottom-item">
              <div class="bor"></div>
              <div class="item-text">如果你是公众号的运营者，点击下方按钮，在授权二维码出来后，把二维码截图发给管理员，授权过程中请不要关闭当前页面，等对方扫码通过后，这边就可以授权成功了。</div>
            </div>
            <div class="bottom-button">
              <iframe  frameborder="0" :src="authLink" style="width: 200px;height: 36px;"></iframe>
            </div>
          </div>
        </div>
<!--        <div class="add-message-img">-->
<!--          <img src="" alt="">-->
<!--        </div>-->
<!--        <div class="qrcode-text">请使用公众号管理员账号，扫码二维码进行授权绑定</div>-->
<!--        <div class="qrcode-button">刷新</div>-->
      </div>
    </el-dialog>
<!--    查看推广链接-->
    <el-dialog
      title="查看推广链接"
      :visible.sync="spread"
      width="30%"
      :before-close="spreadClose">
      <div class="spread-title">推广链接 <span style="color: red">(请将链接放在微信公众号菜单栏)</span></div>
      <a :href="links">{{links}}</a>
      <div class="spread-button" v-clipboard:copy="links" v-clipboard:success="onCopyId" v-clipboard:error="onErrorId">复制链接</div>
    </el-dialog>
    <el-dialog
      title="模板消息提示"
      :visible.sync="hintShow"
      width="30%"
      :before-close="hintShowClose">
      <div class="spread-title" v-for="(item,index) in message":key="index">
        {{item}}
      </div>
    </el-dialog>
    <el-dialog
      title="模板消息提示"
      :visible.sync="reminderShow"
      width="30%"
      :before-close="reminderClose">
      <div class="spread-title">
        {{reminder}}
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {saasIndex} from "@/javaApi/saasIndex";
import { getUserUUID} from '@/utils/auth'
const saasM = new saasIndex()
export default {
  name: "index",
  data(){
    return{
      addOfficial:false, //添加公众号
      spread:false, //推广链接
      pageSize:10,
      pageNo:1,
      list:[], // 公众号列表
      links:'', // 推广链接
      authLink: process.env.VUE_APP_NEW_OPEN_URL + '/third/go/auth-pub?source=SAASMOVIE&goUrl=' + encodeURIComponent(encodeURIComponent(window.location.href)) + '&userUUID='+ getUserUUID() + '&buttonText=点击开始授权公众号',
      canAuthAppNum:'',
      hintShow:false,
      message:[],
      reminder:'',
      reminderShow:false
    }
  },
  mounted() {
    this.getAuthorizationNum()
    this.getList()
    this.webSocket()
  },
  methods:{
    handleClose(){
      this.addOfficial = false
    },
    hintShowClose(){
      this.hintShow = false
    },
    reminderClose(){
      this.reminderShow = false
    },
    spreadClose(){
      this.spread = false
    },
    toPay(type,id){
      this.$router.push({
        path:'/pc/SaasJoin/pay/index',
        query:{
          payStatus:type,
          type:1,
          id:id
        }
      })
    },
    // 获取公众号列表
    getList(){
      let params = {
        pageNo:this.pageNo,
        pageSize:this.pageSize
      }
      saasM.getOfficial(params).then(res=>{
        console.log(res)
        if(res.data.code == 200){
          this.list = res.data.data.list
        }else {
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    // 查看推广链接
    check(id){
      this.spread = true
      let params = {
        id:id
      }
      saasM.checkLinks(params).then(res=>{
        if(res.data.code == 200){
          console.log(res)
          this.links = res.data.data
        }else {
          this.$Message.error(res.data.message)
        }
      })
    },
    onCopyId(){
      this.$Message.success('复制成功')
      this.spread = false
    },
    onErrorId(){
      this.$Message.success('复制失败')
    },
    // 获取可授权数量
    getAuthorizationNum(){
      saasM.getAuthorizationNum().then(res=>{
        if(res.data.code == 200){
          this.canAuthAppNum = res.data.data.canAuthAppNum
          let canAuthAppNum = this.canAuthAppNum.toString()
          if(canAuthAppNum.indexOf('-')!=-1){
            this.canAuthAppNum = 0
            console.log('this.canAuthTicketNum',this.canAuthAppNum)
          }
        }else{
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    // 同步模板消息
    synchronization(item){
      let params = {
        appKey:item.appKey,
        applicationId:2
      }
      saasM.synchronizationMessage(params).then(res=>{
        if(res.data.code == 200){
          console.log(res)
          this.$Message.success('同步消息模板成功')
          this.message = res.data.data
          this.hintShow = true
        }else{
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    webSocket() {
      var that = this
      let webSocket = null;
      let socketOpen = false;
// 发送消息
      let userUUId = localStorage.getItem('userUUID')
      console.log('userUUId',userUUId)
// 初始化websocket
      if ("WebSocket" in window) {
        webSocket = new WebSocket(process.env.VUE_APP_SAAS_MOVIE_WEBSOCKET + 'ws/ticket-order/' + userUUId);
        webSocket.onopen = function () {
          console.log(process.env.VUE_APP_SAAS_MOVIE_WEBSOCKET + 'ws/ticket-order/' + userUUId)
          console.log("连接成功！");
          socketOpen = true
        };
        webSocket.onmessage = function (evt) {
          var received_msg = evt.data;
          console.log("接受消息：" + received_msg);
          let message = JSON.parse(received_msg)
          that.reminder = message.msg
          that.spread = false
          that.reminderShow = true
          that.getList()
        };
        webSocket.onclose = function () {
          console.log("连接关闭！");
        };
        webSocket.onerror = function () {
          console.log("连接异常！");
        };
      }
    }
  }
}
</script>

<style scoped lang="less">
.content-message {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  min-height: 92%;

  .title {
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
    line-height: 25px;
  }
  .official{
    margin-top: 20px;
    width: 65%;
    margin-right: 40px;
    .official-top{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .top-button{
        width: 120px;
        height: 36px;
        background: #FF8622;
        border-radius: 2px;
        text-align: center;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 36px;
        cursor: pointer;
      }
    }
    .official-div{
      height: 80px;
      border-radius: 4px;
      border: 1px solid #EEEEEE;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      margin-top: 20px;
      cursor: pointer;
      .message{
        display: flex;
        align-items: center;
        img{
          width: 40px;
          border-radius: 4px;
          height: 40px;
        }
        .name{
          font-size: 14px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #222222;
          line-height: 20px;
          margin-left: 10px;
        }
      }
      .official-add{
        width: 101px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #FF8622;
        text-align: center;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FF8622;
        line-height: 32px;
        cursor: pointer;
      }
    }
  }
}
.button{
  display: flex;
  align-items: center;
  .button-look{
    width: 115px;
    height: 32px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #EEEEEE;
    text-align: center;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 32px;
    margin-right: 20px;
  }
}
.top-message{
  width: 100px;
  height: 32px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #FF4F76;
  text-align: center;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FF4F76;
  line-height: 32px;
  cursor: pointer;
  margin-left: 20px;
}
.notice-box{
  .auth-title{
    font-size: 20px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
    line-height: 27px;
  }
  .auth-tip{

    .part-box{
      display: flex;
      align-items: center;
      margin-top: 10px;
      .part-circle{
        width: 6px;
        height: 6px;
        background: #999999;
        border-radius: 100%;
      }
      .part-content{
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #666666;
        line-height: 20px;
        margin-left: 8px;
        .sync-template{
          color: #FF4F76;
        }
      }
    }
  }
  .qrcode-box{
    margin-top: 30px;
    display: flex;
    align-items: center;
    .qrcode-div{
      border: 1px solid #EEEEEE;
      border-radius: 4px;
      width: 180px;
      padding: 20px;
      text-align: center;
      img{
        width: 140px;
        height: 140px;
        margin-top: 20px;
        object-fit: contain;
      }
      .nickname{
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #222222;
        line-height: 22px;
        text-align: center;
        margin-top: 10px;
      }
    }
  }
}
.add-message{
  .bottom {
    width: 64%;
    margin: auto;
    display: flex;
    align-items: center;
    .img{
      width: 218px;
      height: 138px;
      margin-right: 70px;
    }

    .bottom-title {
      font-size: 20px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      line-height: 27px;
    }

    .bottom-item {
      display: flex;
      align-items: center;
      margin-top: 20px;

      .bor {
        width: 6px;
        height: 6px;
        background: #FF8622;
        border-radius: 100%;
      }

      .item-text {
        font-size: 16px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #666666;
        line-height: 22px;
        margin-left: 5px;
        width: 99%;
      }
    }
    .bottom-button{
      //width: 124px;
      height: 36px;
      background: #FF8622;
      border-radius: 2px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 36px;
      text-align: center;
      margin-top: 30px;
      cursor: pointer;
      width: 200px;
    }
  }
  .button{
    background: red;
    width: 200px;
    border-radius: 20px;
    margin: auto;
    height: 40px;
  }
  .add-message-img{
    img{
      width: 140px;
      height: 140px;
    }
  }
  .qrcode-text{
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 20px;
    margin-top: 16px;
  }
  .qrcode-button{
    width: 76px;
    height: 32px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #EEEEEE;
    text-align: center;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #3D9EFC;
    line-height: 32px;
    margin: auto;
    margin-top: 20px;
  }
}
.flex{
  display: flex;
  justify-content: space-between;
}
.spread-title{
  font-size: 16px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #222222;
  line-height: 22px;
  margin-bottom: 10px;
}
.spread-button{
  width: 80px;
  height: 28px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #EEEEEE;
  margin: auto;
  margin-top: 30px;
  font-size: 12px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #666666;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
}
/deep/.el-dialog__header{
  border-bottom: 1px solid #e5e5e5;
}
.header-nodata{
  width: 40px;
  height: 40px;
  background: #D8D8D8;
  border-radius: 4px;
}
.active{
  color: #FF8622!important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/SaasJoin/official/index.vue